import { redirect, useActionData, useParams, useRevalidator, useRouteLoaderData, useSubmit } from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import { Autoform } from "../../../../components/forms/autoform";
import { useForm } from "react-hook-form";
import { Alert } from "@mui/material";
import PageTitle from "../../../../components/PageTitle";

export async function action({ request, params }) {
    const id = params.object_id;
    const formData = await request.formData();
    //console.log({ formData, id });

    try {
        const response = await api.patch(`/api/HotelObj/${id}/`, formData)
        return redirect(`/object/${id}/details`);
    }
    catch (e) {
        return e;
    }
    return { status: 400, statusText: 'not ok', message: 'not patched!' }
}

export default function ObjectEditField() {
    const { object_id, field_name } = useParams();
    const submit = useSubmit();
    const form = (useRouteLoaderData('obj_layout')).form;
    const formHook = useForm();
    const actionData = useActionData()
    const revalidator = useRevalidator();

    const handleSubmitForm = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post',
            encType: 'multipart/form-data'
        })
    }
    const fields = {}
    fields[field_name] = form[field_name]

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/details`}
            title={{ text: "Змінити інформацію про об'єкт" }}
            width='md'
        >
            <PageTitle title={`Редагування поля об'єкта: ${field_name || "поле"}`} />
            <Autoform
                formHook={formHook}
                fields={fields}
                onSubmit={handleSubmitForm}
                formName='HotelObj'
                revalidator={revalidator}
            />
            {actionData?.response && (
                <Alert severity='error'>
                    {JSON.stringify(actionData.response)}
                </Alert>
            )}
        </ModalUrlWindow>
    )
}
